module.exports = __webpack_public_path__ + "static/media/06_2.f8ee8e59.png";